import React from "react";
import { Button } from "reactstrap";
import { isB2B } from "../../libs/env";
import { useCustomOrigin } from "../custom_origin/CustomOriginContext";

const B2CNextButton = ({IsonRecorder, ...props}) =>{
    let btn_color = "btn-purple";
    let customOrigin = useCustomOrigin();
    if(isB2B.some(domain => customOrigin.includes(domain)))
    {
        btn_color= "btn-warning";
    }
    return(
    <Button className={
        IsonRecorder
          ? `btn ${btn_color} py-2 rounded-5 disabled btn-lg`
          : `btn ${btn_color} py-2 rounded-5 btn-lg`
        } {...props}>
        <svg width="20" height="19" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className="svg-stroke-color" d="M2.05304 9.46409H17.909M17.909 9.46409L9.981 1.53613M17.909 9.46409L9.981 17.3921" stroke="white" stroke-width="2.26513" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </Button>
)};

export default B2CNextButton;
